











import {Component, Prop, Vue} from 'vue-property-decorator';
import { RouteConfig } from "vue-router";
import { PageRoute } from "@/@types/pageprops";

@Component
export default class Navigation extends Vue {
    @Prop(Array) readonly routes!: (RouteConfig | PageRoute)[];

    get pages(): (RouteConfig | PageRoute)[] {
        return this.routes.filter(route => route.meta && route.meta.nav !== undefined);
    }
}
